var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrerollIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "37px",
    viewBox: "0 0 48 37",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "08598AB5-5CCD-4399-B48C-B16190E4E362") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix",
    values: "0 0 0 0 0.560784 0 0 0 0 0.607843 0 0 0 0 0.662745 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "TurnItBlue---Milestone-2",
    stroke: "none",
    strokeWidth: 1,
    fill: "currentColor",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "12.0_Creatives_20",
    transform: "translate(-1149.000000, -331.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Content",
    transform: "translate(130.000000, 50.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(926.000000, 90.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3-Copy",
    transform: "translate(0.000000, 155.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "laptop-(2)",
    transform: "translate(63.000000, 35.500000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(30.000000, 0.500000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.71047341,0.0676885462 L3.71047341,27.3852344 L43.9957864,27.3852344 L43.9957864,0.0676885462 L3.71047341,0.0676885462 Z M40.2853129,22.131846 L7.42094682,22.131846 L7.42094682,3.74503273 L40.2853129,3.74503273 L40.2853129,22.131846 Z",
    id: "Shape",
    fill: "currentColor",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6533706,11.9623391 L22.3525594,8.16161179 C21.7871329,7.75612927 21,8.16026913 21,8.8561013 L21,16.4577237 C21,17.1535558 21.7871329,17.5576957 22.3525594,17.1522132 L27.6532028,13.3513181 C28.1288392,13.010451 28.1288392,12.303374 27.6533706,11.9623391 Z",
    id: "Path",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.1538927,30.0119748 L29.1538927,32.6386228 L18.5524602,32.6386228 L18.5524602,30.0119748 L0,30.0119748 L0,31.0626709 C0,33.9520392 2.38531765,36.3160594 5.30071624,36.3160594 L42.4056367,36.3160594 C45.3210353,36.3160594 47.7063529,33.9520392 47.7063529,31.0626709 L47.7063529,30.0119748 L29.1538927,30.0119748 Z",
    id: "Path",
    fill: "currentColor",
    fillRule: "nonzero"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrerollIcon);
export default __webpack_public_path__ + "static/media/PrerollIcon.2048eec8234d96013d16c7d6fbcba7a1.svg";
export { ForwardRef as ReactComponent };